{
    "browserTabTitleSeparator": " - ",
    "products": {
        "vla": {
            "applicationName": "VLA Forge"
        },
        "western": {
            "applicationName": "iLabel++"
        }
    }
}
